var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94867 0.625C4.53441 0.625 0.943115 4.2138 0.943115 8.625C0.943115 13.0362 4.53441 16.625 8.94867 16.625C13.3629 16.625 16.9542 13.0362 16.9542 8.625C16.9542 4.2138 13.3629 0.625 8.94867 0.625ZM5.74645 3.0914C6.47015 2.6714 7.28191 2.3898 8.14812 2.281V7.025H10.5498V9.825L8.5564 11.3186L7.1242 7.025H5.74645V3.0914ZM8.94867 15.025C5.41742 15.025 2.54423 12.1538 2.54423 8.625C2.54423 7.0082 3.15185 5.5338 4.14534 4.4058V8.625H5.9698L7.73983 13.9314L12.1509 10.625V5.425H9.74923V2.2802C12.9034 2.6762 15.3531 5.3674 15.3531 8.625C15.3531 12.1538 12.4799 15.025 8.94867 15.025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicContentIcon);
export default __webpack_public_path__ + "static/media/PublicContentIcon.5d31ca28660ff40d49f0a344e547b83f.svg";
export { ForwardRef as ReactComponent };